const PROGRESS_THRESHOLDS = {
  COLOR_SUCCESS: 100,
  COLOR_WARNING: 80
} as const

const COLORS = {
  SUCCESS: '#59ac2a',
  WARNING: '#f0b222',
  ERROR: '#f34455'
} as const

const TREND_THRESHOLDS = {
  NEUTRAL: 0,
  WARNING: -10
} as const

export const calculatePercentage = (value: number, expected: number): number => {
  if (expected <= 0) {
    return 0
  }

  return (value / expected) * 100
}

export const getProgressColor = (progress: number): string => {
  const cappedProgress = Math.max(0, progress)

  if (cappedProgress >= PROGRESS_THRESHOLDS.COLOR_SUCCESS) {
    return COLORS.SUCCESS
  }

  if (cappedProgress >= PROGRESS_THRESHOLDS.COLOR_WARNING) {
    return COLORS.WARNING
  }

  return COLORS.ERROR
}

export const getTrendColor = (percentage: number): string => {
  if (percentage > TREND_THRESHOLDS.NEUTRAL) return COLORS.SUCCESS
  if (percentage >= TREND_THRESHOLDS.WARNING) return COLORS.WARNING
  return COLORS.ERROR
}

export const getTrendSymbol = (percentage: number): string => {
  if (percentage > 0) return '↑'
  if (percentage < 0) return '↓'
  return ''
}
